import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { AuthCard } from "@/pages/Login";
import { errMsg } from "@/lib/api";
import { useT } from "@/i18n";

export default function Register() {
  const { register } = useAuth();
  const { t } = useT();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await register(form); toast.success(t("auth.welcomeToast")); nav("/app"); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <AuthCard title={t("auth.createAccount")} subtitle={t("auth.registerSub")} footer={<>{t("auth.haveAccount")} <Link to="/login" className="text-terracotta font-semibold" data-testid="go-login-link">{t("nav.login")}</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div><label className="label-craft">{t("auth.fullName")}</label><input data-testid="register-name-input" className="input-craft" required value={form.name} onChange={set("name")} /></div>
        <div><label className="label-craft">{t("common.email")}</label><input data-testid="register-email-input" className="input-craft" type="email" required value={form.email} onChange={set("email")} /></div>
        <div><label className="label-craft">{t("auth.phone")}</label><input data-testid="register-phone-input" className="input-craft" value={form.phone} onChange={set("phone")} /></div>
        <div><label className="label-craft">{t("auth.passwordMin")}</label><input data-testid="register-password-input" className="input-craft" type="password" minLength={6} required value={form.password} onChange={set("password")} /></div>
        <button data-testid="register-submit-button" className="btn-primary w-full" disabled={busy}>{busy ? t("auth.creating") : t("nav.register")}</button>
      </form>
    </AuthCard>
  );
}
